import { env } from '@/helpers';

class GrecaptchaAPI {
  static getToken(): Promise<string | null> {
    const grecaptchaKey = env('GRECAPTCHA_KEY');

    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) {
        reject(new Error('grecaptcha not initialized'));
      }

      window.grecaptcha.ready(() => {
        if (typeof grecaptchaKey === 'number') {
          window.grecaptcha.execute(grecaptchaKey, { action: 'submit' }).then((token: string) => {
            resolve(token);
          }).catch(() => {
            reject(new Error('cant fetch token'));
          });
        } else {
          reject(new Error('non numeric token'));
        }
      });
    });
  }
}

export default GrecaptchaAPI;
